const pendingRequests = new Map<string, Promise<unknown>>();

/**
 * Coalesces concurrent requests with the same cache key into one shared promise.
 * @param cacheKey - Stable key (endpoint name + serialized params/body).
 * @param factory - Creates the promise executed once per in-flight key.
 * @returns The shared promise for this key.
 */
export function dedupeRequest<T>(
  cacheKey: string,
  factory: () => Promise<T>
): Promise<T> {
  const existing = pendingRequests.get(cacheKey);
  if (existing) {
    return existing as Promise<T>;
  }
  const requestPromise = factory().finally(() => {
    pendingRequests.delete(cacheKey);
  });
  pendingRequests.set(cacheKey, requestPromise);
  return requestPromise;
}

/**
 * Clears the in-flight map. Intended for unit tests only.
 */
export function clearRequestDedupeForTests(): void {
  pendingRequests.clear();
}
